import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import IntegrationProjectSync from '../IntegrationProjectSync';

const getImportHelpText = (t) => (
  <div style={{ width: 500 }}>
    Select from this dropdown to either
    {' '}
    <b>Import</b>
    {' '}
    new
    {' '}
    {t('Project', { count: 0 })}
    {' '}
    from Sage Intacct
    or
    {' '}
    <b>Link</b>
    {' '}
    Sage Intacct
    {' '}
    {t('Project', { count: 0 })}
    {' '}
    to existing Ontraccr
    {' '}
    {t('Project', { count: 0 })}
    <br />
    <br />
    <b>Import:</b>
    {' '}
    {t('Project', { count: 0 })}
    {' '}
    will be imported into Ontraccr with available details.
    <br />
    <b>Link:</b>
    {' '}
    Select an existing Ontraccr
    {' '}
    {t('Project')}
    {' '}
    to link with the Sage Intacct
    {' '}
    {t('Project', { count: 0 })}
    .
  </div>
);

function SageIntacctProjectSync({
  sageIntacctProjects,
  onProjectsChanged,
  importProjects,
  divisionFilter,
}) {
  const { t } = useTranslation();
  const importHelpText = getImportHelpText(t);
  return (
    <IntegrationProjectSync
      integrationProjects={sageIntacctProjects}
      title="Sage Intacct"
      integrationKey="sageId"
      onProjectsChanged={onProjectsChanged}
      showAutoImport={false}
      showNumber
      importHelpText={importHelpText}
      importProjects={importProjects}
      divisionFilter={divisionFilter}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
SageIntacctProjectSync.propTypes = {
  sageIntacctProjects: PropTypes.array,
  onProjectsChanged: PropTypes.func.isRequired,
  importProjects: PropTypes.array,
  divisionFilter: PropTypes.instanceOf(Set),
};

SageIntacctProjectSync.defaultProps = {
  sageIntacctProjects: [],
  importProjects: [],
  divisionFilter: null,
};

export default SageIntacctProjectSync;

